import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import QuotePayment from "./pages/QuotePayment";
import PaymentSuccess from "./pages/PaymentSuccess";
import Admin from "./pages/Admin";
import Brochure from "./pages/Brochure";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/quote/:token" element={<QuotePayment />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/brochure" element={<Brochure />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
